// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--34965";
export var headingContainer = "index-module--heading-container--577cd";
export var highlight = "index-module--highlight--4f794";
export var highlightLine = "index-module--highlight-line--0902e";
export var image1 = "index-module--image-1--ef26e";
export var image2 = "index-module--image-2--f8adc";
export var imageContainer = "index-module--image-container--8b960";